import { configureStore } from '@reduxjs/toolkit'
import auth_reducer from './slices/AuthSlice'
import cart_reducer from './slices/CartSlice'
import product_reducer from './slices/ProductSlice'
import message_reducer from './slices/MessageSlice'

import SettingSlice from './slices/SettingSlice'
import HomeSlice from './slices/HomeSlice'
import CodeSlice from './slices/CodeSlice'
export const store = configureStore({
  reducer: {
    AuthReducer:auth_reducer,
    CartReducer:cart_reducer,
    ProductReducer:product_reducer,
    MessageReducer:message_reducer,
    SettingReducer:SettingSlice,
    CodeReducer:CodeSlice,
    HomeReducer:HomeSlice,
   
  },  
})